import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    width: "40%",
  },
  iconLoading: {
    color: "#028B7E",
  },
  containerChoiseFilter: {
    marginLeft: "1rem",
    width: 300,
  },
  p: {
    fontSize: 14,
    color: "#5c6865",
    fontWeight: "bold",
  },
  pColor: {
    fontSize: 14,
    color: "#404846ff",
    fontWeight: "bold",
  },
}))

export default useStyles
